import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSentinelChat } from './SentinelChatProvider'
import Drawer from './Drawer'
import AudienceDrillPanel from './AudienceDrillPanel'

/** Right overlay drawer: the conversation-level customer drill-down. */
export default function CustomerInspector() {
  const { t } = useTranslation()
  const { ui, closeInspector } = useSentinelChat()
  const customerId = ui.inspectorCustomerId
  return (
    <Drawer open={!!customerId} onClose={closeInspector} side="right" title={t('Sentinel.V2.customer.title')}>
      {customerId && <AudienceDrillPanel customerId={customerId} />}
    </Drawer>
  )
}
